import { useIntl } from 'react-intl';

import { CmsBanner, CmsBannerType } from '../../../../common/cms-banner';
import { ContentWrapper } from '../../../../common/content-wrapper';
import { useGetBanners } from '../../../../../hooks/use-get-banners';
import { useStyles } from './kids-banner-unregistered.styles';
import { setRedirectUrl } from '../../../../../utils/redirect/redirect';
import { InternalLinks } from '../../../../../constants';

export const KidsBannerUnregistered = (): JSX.Element | null => {
  const classes = useStyles();
  const intl = useIntl();

  const { url, pwaCallToActionLink } = useGetBanners(CmsBannerType.kidsBannerUnreg);

  const handleClick = () => {
    setRedirectUrl(InternalLinks.createProfile);
  };

  return (
    <section className={classes.root} aria-label={intl.formatMessage({ id: 'kidsPage.pageTitle' })}>
      <ContentWrapper>
        <CmsBanner
          url={url}
          pwaCallToActionLink={pwaCallToActionLink}
          onClick={handleClick}
        />
      </ContentWrapper>
    </section>
  );
};
